import { render, staticRenderFns } from "./DiscoveryFlow.vue?vue&type=template&id=2586d7db&scoped=true"
import script from "./DiscoveryFlow.vue?vue&type=script&lang=js"
export * from "./DiscoveryFlow.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryFlow.vue?vue&type=style&index=0&id=2586d7db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2586d7db",
  null
  
)

export default component.exports